//this function will add two list uniquely based on key
export const mergeArrayOfObjects = (arrayA, arrayB, key) => {
  let duplicate = false;
  arrayB.forEach(elementB => {
    duplicate = false;
    arrayA.forEach(elementA => {
      if (elementA[key] === elementB[key]) {
        duplicate = true;
      }
    });
    if (!duplicate) {
      arrayA.push(elementB);
    }
  });
  return arrayA;
};
